import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Label } from 'reactstrap';
import { observer } from 'mobx-react';
import LoadingImage from './LoadingImage';


@observer
export default class LoadingWhapper extends Component {
    static propTypes = {
        value: PropTypes.any,
        loading: PropTypes.bool.isRequired,
        error: PropTypes.string,
        children: PropTypes.oneOfType([
            PropTypes.func.isRequired,
            PropTypes.node.isRequired,
        ]),
        classNames: PropTypes.exact({
            loadingContainer: PropTypes.string,
        }),   
        fallback: PropTypes.node
    }

    render() {
        const { value, loading, error, children, fallback, classNames: { loadingContainer: loadingContainerClassName = "" } = {} } = this.props;

        if (loading) return fallback ? (
            fallback
        ) : (
            <div className={loadingContainerClassName}>
                <LoadingImage className="m-auto" />
            </div>
        );
    
        if (error) return (
            <Label className="label-danger">{error}</Label>
        );
    
        return typeof children == 'function' && value ? children(value) : children;
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/loading/components/LoadingWhapper.js